import '@/styles/style.scss';
import '@/pages/landing/landing.scss';

import '@/components/template/template.js';
import '@/components/dropdown/dropdown.js';
import '@/components/template/template.js';